/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-no-bind */
import PropTypes from 'prop-types';

import Link from 'Component/Link';
import SourceMenuItem from 'SourceComponent/MenuItem/MenuItem.component';

/** @namespace Scandipwa/Component/MenuItem/Component */
export class MenuItemComponent extends SourceMenuItem {
    static propTypes = {
        ...super.propTypes,
        isHighlighted: PropTypes.bool,
        isParent: PropTypes.bool,
        isDeviceDesktop: PropTypes.bool,
        onCategoryClick: PropTypes.func,
        handleSliderItemHover: PropTypes.func,
        isSmall: PropTypes.bool
    };

    static defaultProps = {
        ...super.defaultProps,
        isHighlighted: false,
        isParent: false,
        isDeviceDesktop: false,
        onCategoryClick: () => {},
        handleSliderItemHover: () => {},
        isSmall: false
    };

    handleCategoryClick = (e, item) => {
        const {
            device,
            isDeviceDesktop,
            closeMenu,
            onCategoryClick,
            isParent
        } = this.props;

        if ((device.isMobile || device.android) && isDeviceDesktop && isParent) {
            e.preventDefault();
            onCategoryClick(item);
        } else {
            closeMenu(e, item.url);
        }
    };

    renderItemContentTitle(isBanner, title) {
        if (isBanner) {
            return (
                <button
                  block="Menu"
                  elem="Button"
                  mix={ { block: 'Button' } }
                >
                    { title }
                </button>
            );
        }

        return title;
    }

    renderItemContent(item, itemMods = {}) {
        const { title } = item;
        const { isBanner, type } = itemMods;
        const { isHighlighted, isDeviceDesktop } = this.props;

        return (
            <div
              block="Menu"
              elem="ItemName"
              mods={ { ...itemMods, isHighlighted } }
            >
                { this.renderItemContentTitle(isBanner, title) }
                { !isDeviceDesktop && type && <div block="Icon" elem="Right" /> }
            </div>
        );
    }

    renderItemLinkContent() {
        const {
            activeMenuItemsStack,
            item,
            itemMods,
            handleCategoryHover,
            handleSliderItemHover,
            isParent,
            isSmall
        } = this.props;

        const {
            url,
            item_id
        } = item;

        const isHovered = activeMenuItemsStack.includes(item_id);

        const mix = isParent ? { block: 'Link', elem: 'Menu' } : {};

        return (
            <Link
              to={ url }
              block="Menu"
              elem="Link"
              id={ item_id }
              onMouseEnter={ () => {
                  handleCategoryHover(true);
                  handleSliderItemHover(item);
              } }
              onMouseLeave={ () => {
                  handleCategoryHover(false);
              } }
              mods={ { isHovered, isSmall } }
              onClick={ (e) => {
                  // Is needed for mobile menu
                  // If item has children it will open submenu overlay
                  // If item has no children it will redirect to given link
                  this.handleCategoryClick(e, item);
              } }
              mix={ mix }
            >
                { this.renderItemContent(item, itemMods) }
            </Link>
        );
    }
}

export default MenuItemComponent;
